import { IconActionSearch16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './MobileSearchBlock.css';
import clsx from 'clsx';

interface ISearchBlockProps {
  text?: string;
  placeholder?: string;
  isMainpage: boolean;
  onSearchClick(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const MobileSearchBlock: React.FC<ISearchBlockProps> = ({
  onSearchClick,
  text,
  isMainpage,
  placeholder = 'Например, купить квартиру в Москве',
}) => {
  return (
    <div
      className={clsx(styles['container'], isMainpage && styles['container--mainpage-redesign'])}
      data-name="MobileSearchBlock"
    >
      <a
        href="/nd/search/"
        className={clsx(
          styles['button'],
          styles['geo-button'],
          !text && styles['placeholder'],
          isMainpage && styles['button--mainpage-redesign'],
        )}
        onClick={onSearchClick}
      >
        <span className={styles['icon']}>
          <IconActionSearch16 />
        </span>
        <span className={styles['text']}>{text || placeholder}</span>
      </a>
    </div>
  );
};
